<template>
  <div>
    <el-table
      v-show="!isshowdata"
      :data="styleData"
      :show-header="false"
      :stripe="false"
      :height="tableHeight"
      style="overflow:auto"
      v-loading="loadingNew"
      :lock="false"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      empty-text=" "
      id="style-content"
    >
      <el-table-column label="样式">
        <template slot-scope="scope">
          <div class="styleItem-content" :title="scope.row.name">
            <img
              class="cursor collect"
              v-if="!scope.row.isFavorite"
              @click.stop="
                collect(scope.row.id, scope.row.fixedHtml, scope.row.name)
              "
              src="../../assets/image/collect_16.png"
              height="16"
              width="16"
              alt=""
            />

            <img
              class="cursor collect"
              v-if="scope.row.isFavorite"
              @click.stop="cancelcollect(scope.row.collectId)"
              src="../../assets/image/collected_16.png"
              height="16"
              width="16"
              alt=""
            />

            <div
              class="styleItem"
              v-html="addEditorWrapper(scope.row.fixedHtml, scope.row.id)"
              @click="
                setNewHtml(
                  addEditorWrapper(scope.row.fixedHtml, scope.row.id),
                  scope.row.id
                )
              "
            ></div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="isshowdata" class="nodata">
      {{
        searchWords.length > 0
          ? "抱歉，未找到与“" + searchWords + "”相关样式"
          : "抱歉，未找到相关样式"
      }}
    </div>
  </div>
</template>

<script>
import editorControl from "../../assets/script/utils/editorControl";
import { mapActions } from "vuex";
export default {
  name: "StyleList",
  props: {
    styleData: {
      type: Array
    },
    loadingNew: {
      type: Boolean,
      default: false
    },
    isActiveBtn: {
      type: Number,
      default: 1
    },
    searchWords: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableHeight: 100,
      isshowdata: false
    };
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.tableHeight = this.fixHeight(val, "style-content", 200);
      }
    }
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    }
  },
  updated() {
    this.setHeight();
    // let getid = setInterval(() => {
    //   let getBox = document.getElementById("style-content");
    //   if (getBox) {
    //     clearInterval(getid);
    //     this.tableHeight = this.fixHeight(
    //       this.contentHeight,
    //       "style-content",
    //       125
    //     );
    //   }
    // }, 100);
  },
  mounted() {
    let getid = setInterval(() => {
      let getBox = document.getElementById("style-content");
      if (getBox) {
        clearInterval(getid);
        this.tableHeight = this.setHeight();
        // this.fixHeight(
        //   this.contentHeight,
        //   "style-content",
        //   125
        // );
      }
    }, 100);
  },
  methods: {
    ...mapActions("style", ["AUse", "AFavoriteStyle", "AFavoriteDel"]),
    addEditorWrapper(html, id) {
      html =
        '<section class="_5118editor" styleid="' +
        id +
        '">' +
        html +
        "</section>";

      return html;
    },
    showDataList(type) {
      this.$nextTick(() => {
        this.isshowdata = type;
      });
    },
    setNewHtml(content, id) {
      this.AUse({ styleId: id });
      editorControl.setInnerStyle(content, "样式插入成功");
    },
    async collect(id, fixedHtml, styleName) {
      var result = await this.AFavoriteStyle({
        styleId: id,
        fixedHtml: fixedHtml,
        styleName: styleName
      });
      if (result.errorCode === 0) {
        this.$message({
          showClose: true,
          message: "收藏样式成功",
          type: "success"
        });
        this.styleData.forEach(m => {
          if (m.id === id) {
            m.isFavorite = true;
            m.collectId = result.data;
          }
        });
        // this.item.collectId = result.data;
        // this.item.isFavorite = true;
      } else {
        if (result.errorCode === 300000) {
          this.insertConfig.showLoginMessage(
            true,
            "您当前账号暂未登录，请登录账号享更多权限",
            "scStyle"
          );
        } else {
          this.$message({
            showClose: true,
            message: result.errorMess,
            type: "error"
          });
        }
      }
    },
    async cancelcollect(collectId) {
      var result = await this.AFavoriteDel({
        favoriteStyleIdList: collectId
      });
      if (result.errorCode === 0) {
        this.$message({
          showClose: true,
          message: "取消收藏样式成功",
          type: "success"
        });
        if (this.isActiveBtn === 3) {
          this.$emit("getList", 1);
        } else {
          this.styleData.forEach(m => {
            if (m.collectId === collectId) {
              m.isFavorite = false;
              m.collectId = 0;
            }
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
      }
    },
    setHeight() {
      var _height = 135;

      let getBox = document.getElementById("style-page");
      if (getBox) {
        var height = getBox.offsetHeight;
        if (height === 0) {
          _height = _height - 42;
        }
      }

      return this.fixHeight(this.contentHeight, "style-content", _height);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.styleItem-content {
  position: relative;
  .collect {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 990;
    // display: none;
  }
  &:hover .collect {
    // display: block;
  }
  .styleItem {
    max-width: 465px !important;
    box-sizing: border-box !important;
    -webkit-box-sizing: border-box !important;
    word-wrap: break-word !important;
    cursor: pointer;
    overflow: visible;
    line-height: 1.6;
    font-size: unset !important;
    -webkit-max-logical-width: 100%;
    margin: 0;
    img {
      max-width: 100% !important;
    }

    div {
      max-width: 100% !important;
    }
    section {
      max-width: 100% !important;
    }
  }
}
.nodata {
  color: #666;
}
/deep/.el-table__body-wrapper {
  overscroll-behavior-y: contain;
  overflow-y: auto;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-icon--right {
  font-size: 10px;
}

.styleTagPanel {
  padding: 10px;
  border-bottom: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px dashed #e6e6e6;
}

.el-card__header {
  padding: 5px;
}

.el-alert {
  padding: 5px 0px 5px 0px !important;
  border-radius: 0px !important;
}

.styleDataTable {
  border-right: 1px solid #e6e6e6;
}

.linkButton {
  cursor: pointer;
}

.el-table .cell {
  line-height: normal !important;
  overflow: visible !important;
}
</style>
